export  const PlayModeTypes = {
    ALL: {
        title: "همه",
        id: "All"
    },
    SINGLE: {
        title: "انفرادی",
        id: "SINGLE"
    },
    MULTI: {
        title: "گروهی",
        id: "MULTI"
    }
}